import React from "react";
import ReactDOM from "react-dom/client";
import StreetSmartTrucker from "./StreetSmartTrucker";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<StreetSmartTrucker />);
